import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Projections to Be Used Globally",
description: "Learn how to define global projection settings in Freon, including default boolean, limited concept, and number projections, reference separators, and external components.",
tags: [ "global projections", "editor defaults", "boolean projections", "limited concepts", "number projections", "reference separator", "external components", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.373Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};